import Konva from "konva";
import { Shape } from "konva/types/Shape";
import React, { ReactElement, useCallback, useRef } from "react";
import { Group, Rect, Text } from "react-konva";
import { setMousePointer, unsetMouse } from "utils/mouse-cursor-utils";

const PADDING = 10;
const SPACING = 10;

export const KonvaButton = ({
  x,
  y,
  text,
  textColor,
  backgroundColor,
  hoverColor,
  Icon,
  onClick,
}: {
  x: number;
  y: number;
  text: string;
  textColor: string;
  Icon: ReactElement;
  backgroundColor: string;
  hoverColor: string;
  onClick?: () => void;
}) => {
  const iconRef = useRef<Konva.Node>(null);
  const textRef = useRef<Konva.Text>(null);
  const rectRef = useRef<Konva.Rect>(null);

  const { width: iconWidth, height: iconHeight } = (iconRef.current as Shape | undefined)?.getSelfRect() ?? {
    width: 0,
    height: 0,
  };
  const { width: textWidth, height: textHeight } = (textRef.current as Shape | undefined)?.getSelfRect() ?? {
    width: 0,
    height: 0,
  };

  const totalWidth = iconWidth + textWidth + PADDING + SPACING;
  const totalHeight = textHeight + PADDING;

  const onMouseEnterCB = useCallback(
    (event: Konva.KonvaEventObject<MouseEvent>) => {
      rectRef?.current?.fill(hoverColor);
      rectRef?.current?.getLayer()?.batchDraw();
      setMousePointer(event);
    },
    [hoverColor]
  );
  const onMouseOutCB = useCallback(
    (event: Konva.KonvaEventObject<MouseEvent>) => {
      rectRef?.current?.fill(backgroundColor);
      rectRef?.current?.getLayer()?.batchDraw();
      unsetMouse(event);
    },
    [backgroundColor]
  );

  return (
    <Group x={x} y={y}>
      <Rect
        ref={rectRef}
        x={0}
        y={0}
        fill={backgroundColor}
        width={totalWidth}
        height={totalHeight}
        listening={false}
      />
      {React.cloneElement(Icon, {
        ref: iconRef,
        y: (totalHeight - iconHeight) / 2,
        x: PADDING / 2,
      })}
      <Text
        ref={textRef}
        x={PADDING + iconWidth / 2 + SPACING}
        y={PADDING / 2 + 1.5}
        text={text}
        fill={textColor}
        fontSize={15}
        fontFamily="Poppins"
        fontWeight={300}
      />
      <Rect
        x={0}
        y={0}
        width={totalWidth}
        height={totalHeight}
        onMouseEnter={onMouseEnterCB}
        onMouseOut={onMouseOutCB}
        onClick={(e) => {
          onClick?.();
          e.cancelBubble = true;
        }}
      />
    </Group>
  );
};
